import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import Providers from './Providers/Provider'
import { BrowserRouter } from 'react-router-dom'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
    // <React.StrictMode>
    <BrowserRouter basename="/wsOnePortaria/Plus">
        <Providers>
            <App />
        </Providers>
    </BrowserRouter>
    // </React.StrictMode>
)

/* NÃO REMOVER */
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log)
